import { render } from "./totpModal.vue?vue&type=template&id=2bec64b3"
import script from "./totpModal.vue?vue&type=script&lang=js"
export * from "./totpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__